import { useMutation } from "@tanstack/react-query";
import { updateLeatCredentials } from "../../api/bLeatApi";

export const useUpdateLeat = () => {
  return useMutation({
    mutationKey: ["update-leat"],
    mutationFn: (data) => updateLeatCredentials(data),
    onError: (error) => {
      console.error("Leat update error details:", error.response || error);
    },
  });
};
